export default function (props) {
    
    const { participantschools,eventgendermen,eventgenderwomen, eventSeasonSettings   } = props 
    let menteams
    let womenteams
    let meetCriteria = false

    if(eventSeasonSettings){
      
      const{ minWomenTeams,minMenTeams } = eventSeasonSettings
      
      if(eventgendermen && eventgenderwomen){

        menteams   = participantschools.filter(school => school.menteam === true)
        womenteams = participantschools.filter(school => school.womenteam === true)
        
        if(eventgenderwomen && eventgendermen)
        {
            if(menteams && womenteams){
              if(menteams.length >=  minMenTeams  && womenteams.length >= minWomenTeams)
              {
                meetCriteria = true
              }
            }
        }
      }
      else if (eventgendermen) {
        
        menteams = participantschools.filter(school => school.menteam === true)
        
        if(menteams){
          if(menteams.length >= minMenTeams)
              {
                meetCriteria = true
              }
        }
      } 
      else if(eventgenderwomen){
        
        womenteams = participantschools.filter(school => school.womenteam === true)
        
        if(womenteams){
          if(womenteams.length >= minWomenTeams)
          {
            meetCriteria = true
          }
        }
      }
    }
    return meetCriteria
}


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/EventTemplate/Logic/minimumTeamCriteria.js